module.exports = __webpack_public_path__ + "img/el-sabor-que-te-premia.04f78419.png";